import script from "./PurchaseReq.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseReq.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseReq.vue?vue&type=style&index=0&id=6bc1dd57&lang=css"

const __exports__ = script;

export default __exports__